import { useState } from "react";
import Botão from "../Botão";
import CampoTexto from "../CampoTexto";
import ListaSuspensa from "../ListaSuspensa";
import "./Formulario.css";

const Formulario = (props) => {


  const [nome, setNome] = useState('')
  const [cargo, setCargo] = useState('')
  const [imagem, setImagem] = useState('')
  const [time, setTime] = useState('')



  const aoSalvar = (evento) => {
    evento.preventDefault()
    console.log('Form foi submetido', nome, cargo, imagem)
    props.aoColaboradorCadastrado({
      nome,
      cargo,
      imagem,
      time
  })
    setNome('')
    setCargo('')
    setImagem('')
    setTime('')
}



  return (
    <section className="formulario">
      <form onSubmit={aoSalvar}>
        <h2>Preencha os dados para criar o card do colaborador</h2>
        <CampoTexto 
        obrigatorio={true} 
        label="Nome" 
        placeholder="Digite o seu nome" 
        valor = {nome}
        aoAlterado = {valor => setNome(valor)}
        />

        <CampoTexto 
        obrigatorio={true} 
        label="Cargo" 
        placeholder="Digite o seu cargo" 
        valor = {cargo}
        aoAlterado = {valor => setCargo(valor)}
        />

        <CampoTexto 
        label="Imagem" 
        placeholder="Digite o endereço da 
        imagem" 
        valor = {imagem}
        aoAlterado = {valor => setImagem(valor)}
        />

        <ListaSuspensa 
        obrigatorio={true} 
        label="Time"
         itens={props.times}
         valor = {time}
         aoAlterado = {valor => setTime(valor)} 
         />

        <Botão texto="Criar card" />
      </form>
    </section>
  );
};

export default Formulario;
